import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import type { PartnerNames } from '~/api/partner-promo-code/types'

export function hasPartnerPromoCode(
  partnerPromoCodes: GetProductResponse['includedServiceOffers']['partnerPromoCodes'],
  partnerName: PartnerNames,
) {
  if (isEmpty(partnerPromoCodes)) return false

  return partnerPromoCodes?.some(
    (partnerPromoCode) => partnerPromoCode.partnerName === partnerName,
  )
}
